<ng-container [formGroup]="form">
  <div class="input-field">
    <span class="label">{{label}}</span>
    <div class="input">
      <input
        name="input" 
        formControlName="input" 
        [min]="min" 
        [max]="max" 
        [type]="inputType" 
        [placeholder]="placeholder" 
        [autocomplete]="autocomplete"
        (focus)="onTouchInput($event)" 
        (input)="onInput($event)" />
       <ng-content select="[icon]"></ng-content>
    </div>
    <!-- error message Validator  -->
    <app-error-validation-message [control]="formControl" [errors]="formControl.errors"></app-error-validation-message>
  </div>
</ng-container>
